export enum QuoteInvoiceState {
  Invoiced = 'invoiced',
  PartiallyInvoiced = 'partiallyInvoiced',
  NotInvoiced = 'notInvoiced',
}
